// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.album-share.loading-icon[data-v-2f20a9c4]{height:350px}span.field-title[data-v-2f20a9c4]{color:var(--color-text-lighter)}`, "",{"version":3,"sources":["webpack://./components/modal/AlbumShareModal.vue"],"names":[],"mappings":"AACA,2CACE,YAAA,CAGF,kCACE,+BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
